import { render, staticRenderFns } from "./band.vue?vue&type=template&id=04c4c6d8&scoped=true&"
import script from "./band.vue?vue&type=script&lang=js&"
export * from "./band.vue?vue&type=script&lang=js&"
import style0 from "./band.css?vue&type=style&index=0&id=04c4c6d8&scoped=true&lang=css&"
import style1 from "./shared.css?vue&type=style&index=1&id=04c4c6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c4c6d8",
  null
  
)

export default component.exports